const runCond = document.querySelector('.gridInfluenceurs');

const influenceurs = {
    init: function () {
        this.isTopStarElem = document.querySelector('#isTopStar');
        this.isTopValue = this.isTopStarElem.checked;
        this.genderValue = 'all';
        this.thematiqueValue = 'all';

        this.influenceursCards    = document.querySelectorAll('.influenceurCard');

        this.attachEvents();
    },

    attachEvents: function () {

    /* Filters START */
        this.isTopStarElem.addEventListener('change', () => {
            this.isTopValue = this.isTopStarElem.checked;
            this.influenceursCards.forEach((el) => {
                let temp = el.dataset.thematiques.split(',');
                if (el.dataset.top == false && this.isTopValue == true) {
                          el.style.display = 'none';
                } else {
                    if (this.thematiqueValue == 'all' || temp.includes(this.thematiqueValue)) {
                        if (el.dataset.gender == this.genderValue || this.genderValue == 'all') {
                            el.style.display = 'block';
                        }
                    }
                }
            });
        });

        document.addEventListener('click', (e) => {
            if (e.target.classList.contains('genderButton')) {
                document.querySelectorAll('.genderButton').forEach((el) => {
                    el.classList.remove('active');
                  });
                e.target.classList.add('active');
                this.genderValue = e.target.dataset.gender;
                this.influenceursCards.forEach((el) => {
                      let temp = el.dataset.thematiques.split(',');
                    if ((el.dataset.gender == this.genderValue || this.genderValue == 'all')) {
                        if (el.dataset.top == true || this.isTopValue == false) {
                            if (this.thematiqueValue == 'all' || temp.includes(this.thematiqueValue)) {
                                el.style.display = 'block';
                            }
                        }
                    } else {
                        el.style.display = 'none';
                    }
                  });
            }
        });

        document.getElementById('selectThematique').addEventListener('change', (elem) => {
              this.thematiqueValue = elem.target.value;
              this.influenceursCards.forEach((el) => {
                    let temp = el.dataset.thematiques.split(',');
                    console.log(temp.includes(this.thematiqueValue));
                    if (this.thematiqueValue != 'all' && temp.includes(this.thematiqueValue) == false) {
                        el.style.display = 'none';
                    } else {
                        console.log('ok', el.dataset.gender, this.genderValue);
                        if (el.dataset.top == true || this.isTopValue == false) {
                            if (el.dataset.gender == this.genderValue || this.genderValue == 'all') {
                                el.style.display = 'block';
                            }
                        }
                    }
                });
        });
    /* Filters END didn't have time to do better ~_~ */
    },
};


if (runCond) {
    influenceurs.init();
}



// WEBPACK FOOTER //
// ./scripts/influenceurs.js